export default "<div *ngIf=\"show\" [class.centered]=\"center\">\n  <i class=\"{{ icon }} fa-{{ animation }} fa-{{ size }}\"></i>\n</div>\n";